<template>
  <div>
    <div class="page-banner">
      <div
        class="container"
        style="
            background-image: url('https://downloads.acs.com.hk/page-headers/2017-corporate-profile.jpg?5fc8a9b6a0943');
          "
      >
        <div class="wrapper">
          <div class="content">
            <h1>
              <a class="title">Our Story</a>
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container corporate-profile">
      <div class="row">
        <div class="col-md-10 offset-md-1">
          <div
            class="page-content"
            itemscope
            itemtype="http://schema.org/WebPage"
          >
            <!-- <div class="row">
                <div class="col-xs-12 form-inline text-right">
                  <div class="form-group">
                    <label for="email">Translate this page to</label>
                    <select class="select-corporate-profile form-control">
                      <option value="en" selected>English</option>
                      <option value="cn">中文</option>
                      <option value="jp">日本語</option>
                      <option value="ge">Deutsch</option>
                      <option value="fr">Français</option>
                      <option value="kr">한국어</option>
                      <option value="nl">Nederlands</option>
                      <option value="ru">Русский</option>
                      <option value="tr">Türkçe</option>
                    </select>
                  </div>
                  <br />
                  <br />
                </div>
              </div> -->
            <div id="corporate-profile-content">
              <p>
                TBS Solutions was established in 1993 and formally known as
                Transformative Business Solutions Sdn. Bhd. and was renamed to
                TBS Solutions Sdn. Bhd. in 1996. In it 23 years of computer
                software development experiences and with its core value of
                providing Transformative Business Solutions as its business, TBS
                has helped its clients to be more productive and efficient by
                delivering creative BUSINESS SOLUTIONS its clients.
              </p>
              <br />
              <p>
                TBS’s solutions range from Manufacturing, Trading, Servicing and
                retail stores range from single outlets to nationwide multi
                chain stores enterprise companies. We deliver the most
                appropriate and cost-effective solutions. In additions, prior to
                developing a system, we access the clients’ needs and provide
                business consultancy. After developing the system, we train the
                users and make sure the system is properly implemented and
                maintained.
              </p>
              <br />
              <p>
                TBS is always kept up to date of the latest technologies and
                continuously investing in research and development (R&D) to
                deliver cutting edge solutions to its clients so that the
                clients can take the advantages of latest technology to compete
                in this highly competitive market.
              </p>
              <h5></h5>
              <!-- <h5>Company Mission</h5>
                <p>
                  To strengthen its leading position as a provider of card and
                  reader technology in the world.
                </p>
                <h5>Company Vision</h5>
                <p>
                  Combine scientific spirit and Confucius thoughts to build a
                  sustainable electronic and IT business that is green in order
                  to achieve the dual purposes of business growth and
                  environmental protection.
                </p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<div class="container text-center"><a href="https://www.acs.com.hk/webservice/acs/?lang=en&page=corporate-profile&id=0&type=&ip=121.121.5.105" target="_blank"><small>data source</small></a></div>-->
  </div>
</template>

<script>
export default {
  name: "OurStory"
};
</script>
